import React from 'react'
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom'

import Home from './home'
import DateList from './date-list'
import SingleDay from './single-day'
import Page404 from '../404'
import useBaseFontSize from '@/hooks/useBaseFontSize'

const Router = () => {
  const { path } = useRouteMatch()
  useBaseFontSize()

  return (
    <>
      <Switch>
        <Route path={`${path}`} exact render={() => <Redirect to={`${path}/home`}></Redirect>}>
        </Route>
        <Route exact path={`${path}/home`}>
          <Home></Home>
        </Route>
        <Route exact path={`${path}/date-list`}>
          <DateList></DateList>
        </Route>
        <Route exact path={`${path}/single-day`}>
          <SingleDay></SingleDay>
        </Route>
        <Route>
          <Page404 />
        </Route>
      </Switch>
    </>
  )
}

export default Router